import {IosDeviceDependencies as Dependencies} from '../types';
import {isNativeWebView} from '../isNativeWebView';

function isInstallableWebApp(di: Dependencies = {}): boolean {
  const {wndw = window} = di;
  const {navigator} = wndw as any;
  return 'standalone' in navigator && !navigator.standalone;
}

export function canInstallApp(di: Dependencies = {}): boolean {
  return isInstallableWebApp(di) && !isNativeWebView(di);
}
